import React, { useEffect, createElement } from 'react';
import { CheckCircle, Users } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaAiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'Book-Call-PV');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const wistiaEmbedScript = document.createElement('script');
    wistiaEmbedScript.src = 'https://fast.wistia.com/embed/1n1c7tnsqb.js';
    wistiaEmbedScript.async = true;
    wistiaEmbedScript.type = 'module';
    document.head.appendChild(wistiaEmbedScript);
    const wistiaStyle = document.createElement('style');
    wistiaStyle.textContent = `wistia-player[media-id='1n1c7tnsqb']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1n1c7tnsqb/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(wistiaStyle);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(wistiaEmbedScript);
      document.head.removeChild(wistiaStyle);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-2708">
      {/* Hero Section */}
      <section className="pt-6 md:pt-20 pb-12 md:pb-16 bg-gradient-to-b from-gray-900 to-black" data-id="element-2709">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-2710">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 leading-tight text-center tracking-tight" data-id="element-2711">
            Agenda Tu Llamada de Claridad
          </h1>

          {/* Wistia Video */}
          <div className="mb-8 rounded-2xl overflow-hidden border-2 border-cyan-500 shadow-2xl" data-id="element-2712">
            <wistia-player media-id="1n1c7tnsqb" aspect="1.7777777777777777" data-id="element-2713"></wistia-player>
          </div>

          {/* Qualification Message */}
          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-2xl p-6 md:p-8 border-2 border-cyan-500 mb-8 shadow-2xl" data-id="element-2714">
            <div className="flex items-start gap-4 mb-4" data-id="element-2715">
              <CheckCircle className="w-6 h-6 md:w-7 md:h-7 text-cyan-400 flex-shrink-0 mt-1" data-id="element-2716" />
              <div data-id="element-2717">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-2718">
                  Proceso de Calificación
                </h2>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-2719">
                  Para poder hablar con nuestro equipo, primero debemos
                  verificar si eres un buen candidato para esta oportunidad. Por
                  favor, completa el formulario a continuación para agendar tu
                  llamada de claridad.
                </p>
              </div>
            </div>
          </div>

          {/* Benefits List */}
          <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700 mb-10" data-id="element-2720">
            <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-2721">
              <Users className="w-6 h-6 text-cyan-400" data-id="element-2722" />
              En esta llamada descubrirás:
            </h3>
            <div className="space-y-3" data-id="element-2723">
              {['Si 48/hrs AI Cash Machine es adecuado para tu situación actual', 'Cómo implementar el sistema paso a paso en tu negocio', 'Estrategias personalizadas para tu nicho específico', 'Respuestas a todas tus preguntas sobre el programa'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-2724">
                  <CheckCircle className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-2725" />
                  <span className="text-gray-200 text-sm md:text-base" data-id="element-2726">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-12 md:py-16 bg-gradient-to-b from-black to-gray-900" data-id="element-2727">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-2728">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700" data-id="element-2729">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 text-center" data-id="element-2730">
              ¿Qué Esperar de la Llamada?
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-2731">
              <div className="space-y-3" data-id="element-2732">
                <div className="flex items-start gap-3" data-id="element-2733">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-2734">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-2735" />
                  </div>
                  <div data-id="element-2736">
                    <p className="font-semibold text-white text-sm" data-id="element-2737">
                      Duración: 30-45 minutos
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-2738">
                      Tiempo suficiente para conocerte
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-2739">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-2740">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-2741" />
                  </div>
                  <div data-id="element-2742">
                    <p className="font-semibold text-white text-sm" data-id="element-2743">
                      Formato: Video llamada
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-2744">
                      Conexión personal y directa
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-2745">
                <div className="flex items-start gap-3" data-id="element-2746">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-2747">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-2748" />
                  </div>
                  <div data-id="element-2749">
                    <p className="font-semibold text-white text-sm" data-id="element-2750">
                      Sin presión de venta
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-2751">
                      Solo asesoría honesta
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-2752">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-2753">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-2754" />
                  </div>
                  <div data-id="element-2755">
                    <p className="font-semibold text-white text-sm" data-id="element-2756">
                      Plan personalizado
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-2757">
                      Adaptado a tu situación
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-2758" />
      <WhatsAppButton data-id="element-2759" />
    </div>;
}